import React, { useCallback } from 'react';
import {
  Box,
  BoxProps,
  Button,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

import { FormattedMessage } from 'react-intl';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router';
import { SessionService } from '../../services';

const CongratulationsActionWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
  padding: '1rem 16px 3.125rem 16px',
  [theme.breakpoints.up('sm')]: {
    padding: '1rem 32px 3.125rem 32px',
  },
}));
type Props = {}

export function CongratulationsActions(props: Props) {
  const navigate = useNavigate();

  const logoutHandler = useCallback((e: React.MouseEvent<HTMLElement>): void => {
    e.preventDefault();
    SessionService.signOut();
    navigate('/login');
  }, [navigate]);

  const backToPlansHandler = useCallback((e: React.MouseEvent<HTMLElement>): void => {
    e.preventDefault();
    navigate('/plans');
  }, [navigate]);

  return (
    <CongratulationsActionWrapper>
      {/* There will be code here to hide this first button
      if there are no other plans for the user to switch */}
      <Button variant="outlined" color="primary" onClick={backToPlansHandler}>
        <FormattedMessage id="congratulations.backtoplans" />
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={logoutHandler}
        endIcon={<LogoutIcon />}
      >
        <FormattedMessage id="congratulations.logout" />
      </Button>
    </CongratulationsActionWrapper>
  );
}
